import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/index';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  public showSpinner: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() { }

  public startSpinner(): void {
    this.showSpinner.next(true);
  }

  public stopSpinner(): void {
    this.showSpinner.next(false);
  }
}
